module.exports = __webpack_public_path__ + "static/media/creditCard-sticker.b7d456ab.svg";